import { FlexboxGrid } from 'rsuite';
import { useFeed } from '../../../contexts/feed';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { VIDEO_BASE_URL, getSingleNewsFeed } from '../../../core';
import { CustomLoader } from '../../../components/basic/loader';
import ReactPlayer from 'react-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faShareAlt } from '@fortawesome/free-solid-svg-icons';
// import PlayIcon from '../../../assets/icons/play.svg';
// import PauseIcon from '../../../assets/icons/pause.svg';
// import { useCallback, useRef, useState } from 'react';
// import { PlayIcon } from '../../../components/basic/loader';

// let timeoutId: ReturnType<typeof setTimeout>;

export const SingleFeed = () => {
  const { id } = useParams();
  const { feed } = useFeed();
  // const [controlsVisible, setControlsVisible] = useState(false);
  // const [videoPlaying, setVideoPlaying] = useState(true);
  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const vidRef = useRef<any>(null);

  // const handleToggleVideo = useCallback(() => {
  //   try {
  //     clearTimeout(timeoutId);
  //   } catch (e) {
  //     // pass
  //   }
  //   if (!vidRef.current) return;
  //   if (videoPlaying) vidRef.current.pause();
  //   else {
  //     vidRef.current.play();
  //     timeoutId = setTimeout(() => {
  //       setControlsVisible(false);
  //     }, 1000);
  //   }
  //   setVideoPlaying((pre) => !pre);
  // }, [videoPlaying]);

  // const handleToggleControls = (state: boolean) => {
  //   try {
  //     clearTimeout(timeoutId);
  //   } catch (e) {
  //     // pass
  //   }
  //   setControlsVisible(state);
  // };

  const feedBodyQuery = useQuery({
    queryKey: ['single-feed', id],
    queryFn: async () => {
      if (feed) {
        return feed;
      }
      const res = await getSingleNewsFeed(parseInt(id ?? ''));

      return res.data;
    }
  });

  const linkToShare = `https://fapi.faraad.org/api/share_post/`; // Replace with your dynamic link

  const shareContent = async (link: string, title: string) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: `این پست رو توی مدمی دیدم و به نظرم مفید بود. توهم ببینش، روی لینک پایین بزن تا ببینیش ! ${link}`
        });
      } catch (error) {
        console.error('خطای اشتراک گذاری', error);
      }
    } else {
      alert('این دستگاه قابلیت اشتراک گذاری را پشتیبانی نمی کند!');
    }
  };

  const copyToClipboard = async ($id: string) => {
    if (!navigator.clipboard) {
      console.error('قابلیت کلیپبورد برای کپی کردن وجود ندارد!');
      return;
    }
    try {
      await navigator.clipboard.writeText(
        'این پست رو توی مدمی دیدم و به نظرم مفید اومد، توهم ببینش مفیده! روی لینکش بزن تا باز بشه. ' +
          linkToShare +
          $id
      );
      alert(
        'لینک اشتراک به درستی کپی شد! حالا میتونی توی هر شبکه اجتماعی که بخوای جاگذاریش کنی و برای دوستات بفرستی.'
      );
      // shareLink(linkToShare + $id);
      await shareContent(linkToShare + $id, 'این پست رو توی مدمی ببین!');
    } catch (err) {
      console.error('لینک کپی نشد!', err);
    }
  };

  /*const shareLink = (link: string) => {
          const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(link)}`;
          const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(link)}`;
          const instagramUrl = `https://www.instagram.com/?url=${encodeURIComponent(link)}`;

          const sharePrompt = `اشتراک گذاری پست در یکی از شبکه های اجتماعی زیر:\n\n${link}\n\nپس از زدن دکمه تایید شماره شبکه اجتماعی مورد نظر را انتخاب کنید:\n\n1. WhatsApp\n2. Telegram\n3. Instagram\n\nهمچنین میتوانید پس از بسته شدن این پیام لینک کپی شده پست را در جای دلخواه خود جاگذاری کنید..`;

          if (window.confirm(sharePrompt)) {
            const choice = prompt(
              'برای اشتراک در واتس اپ عدد1، در تلگرام عدد 2 و در اینستاگرام عدد 3 را وارد کنید.):'
            );
            switch (choice) {
              case '1':
                window.open(whatsappUrl, '_blank');
                break;
              case '2':
                window.open(telegramUrl, '_blank');
                break;
              case '3':
                window.open(instagramUrl, '_blank');
                break;
              default:
                alert('عدد اشتباه را وارد کردید، مجدد سعی کنید.');
            }
          }
        };
      */
  return (
    <>
      <FlexboxGrid className="mt-3 px-1.5">
        {!feedBodyQuery.isLoading ? (
          <>
            <div className="relative w-[100%]">
              {/* {controlsVisible ? (
                <div
                  className="w-full h-full absolute bg-[#0008]"
                  onClick={() => handleToggleControls(false)}
                  style={{ zIndex: 1 }}></div>
              ) : (
                <div
                  className="w-full h-full absolute"
                  onClick={() => handleToggleControls(true)}
                  style={{ zIndex: 1 }}></div>
              )} */}
              {/* {controlsVisible ? (
                <div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    width: '12%',
                    zIndex: 2,
                    transform: 'translate(-50%, -50%)'
                  }}
                  onClick={() => {
                    handleToggleVideo();
                  }}>
                  {videoPlaying ? (
                    <img className="w-full" src={PauseIcon} alt="" />
                  ) : (
                    <img className="w-full" src={PlayIcon} alt="" />
                  )}
                </div>
              ) : null} */}
              <div className="max-w-[100%] w-full h-fit">
                <ReactPlayer
                  className="max-w-[100%] custom-video"
                  style={{ height: 'unset!important', width: '100%!important' }}
                  url={`${VIDEO_BASE_URL}/${feedBodyQuery.data.video_name}`}
                  controls
                  config={{
                    file: {
                      attributes: {
                        controlsList: 'nodownload'
                      }
                    }
                  }}
                />
              </div>
              {/* <video style={{ width: '100%' }} ref={vidRef} autoPlay>
                <source
                  src={`${VIDEO_BASE_URL}/${feedBodyQuery.data.video_name}`}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video> */}
            </div>
            <div className="px-2 text-base1 text-justify">
              {/* prettier-ignore */}
              <a className="share-button mt-2 mb-2"
                               onClick={(e) => {
                                   e.preventDefault();
                                   copyToClipboard(feedBodyQuery.data.id);
                               }}
                               href='#' target="_blank" rel="noreferrer">
                                <FontAwesomeIcon className="m-2" icon={faShareAlt}/> اشتراک گذاری
                            </a>
              <h1 className="text-lg mt-2 font-normal">{feedBodyQuery.data.title}</h1>
              {feedBodyQuery.data.body.split('\n').map((line: string, index: number) => (
                <p key={index} className="mt-0">
                  {line}
                  <br />
                </p>
              ))}
              {/* prettier-ignore */}
              <a className="share-button mt-4 mb-4" href="https://app.medme.clinic/feed/">
                                <FontAwesomeIcon className="m-2" icon={faArrowRight}/>دیدن پست های دیگر
                            </a>
            </div>
          </>
        ) : (
          <CustomLoader />
        )}
      </FlexboxGrid>
    </>
  );
};
